import { Component } from "@angular/core";
import { ClientNotificationService } from "../../app/client-notification.service";
import { UserInfoService } from "../user-info.service";
import { UserService } from "../../../swaggerServices";

@Component({
    selector: "app-report",
    templateUrl: "./report.component.html",
    styleUrls: ["./report.component.scss"],
    standalone: false
})
export class ReportComponent {
  isOpen = false;
  report = {
    message: "",
    attachments: new Map(),
  }
  modalImgSrc: string = "";

  constructor(
    private userInfoService: UserInfoService,
    private clientNotificationService: ClientNotificationService,
    private userService: UserService,
  ) { }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  async submit(): Promise<void> {
    const tokenObject = await this.userInfoService.getAdToken();
    const accountInfo = tokenObject?.account;

    if (!tokenObject || !accountInfo) {
      this.clientNotificationService.appendMessage("Error", "Please login before reporting an issue");
      return;
    }

    const { username } = accountInfo;
    const html = await email(username, this.report.message, this.report.attachments);
    const subject = '[Speedcube] User issue report';
    const notificationData = { subject, html, from: username };
    const emailPayloadAsFile = new Blob([JSON.stringify(notificationData)], { type: "text/plain" });

    this.userService.notifyOnUserBehalf(emailPayloadAsFile).subscribe(
      () => {
        this.clientNotificationService.appendMessage("Success", "Report successfully sent", true);
        this.toggle();
        this.report = {
          message: "",
          attachments: new Map(),
        };
      }
    );
  }

  setModal(src?: string) {
    this.modalImgSrc = src ?? null;
  }
}

const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });


const email = async (
  reporter: string,
  details: string,
  attachments: Map<string, File>
) => {
  const imagesHtml = await Promise.all(
    Array.from(attachments.entries()).map(async ([name, file]) => {
      const base64 = await fileToBase64(file);

      return `
        <div>
          <img src="${base64}" alt="${name}" />
        </div>
      `;
    })
  );

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Issue report</title>
</head>
<body>
  <h1>Issue report</h1>
  <ul>
    <li>Reported by: ${reporter}</li>
    <li>Time: ${new Date(performance.timeOrigin + performance.now()).toString()}</li>
    <li>Issue details: ${details}</li>
  </ul>
  <div>
    <h3>Attached screenshots</h3>
    ${imagesHtml.join("") || "<p>No images attached</p>"}
  </div>
</body>
</html>
`;
};
